import classes from "./DashCard.module.css";
export default function DashCard({ children }) {
  return (
    <>
      <div className={classes.container}>{children}</div>
    </>
  );
}
